export default {
  'meta': {
    'langName': 'THAI',
    'lang': 'ไทย'
  },
  'title': 'ประกาศเรียกคืนสินค้า: แป้นบาสเกตบอลรุ่น B900 Box NBA TARMAK',
  'description': 'เรียนลูกค้าผู้มีอุปการคุณ,\n\nท่านได้ทำการสั่งซื้อห่วงบาสเกตบอลรุ่น Tarmak B900 BOX NBA ซึ่งทางเราขอขอบคุณเป็นอย่างยิ่งสำหรับความไว้วางใจ\n\nเพื่อเป็นส่วนหนึ่งของความมุ่งมั่นในการดูแลคุณภาพและความปลอดภัยของผลิตภัณฑ์ ทีมงานบาสเกตบอลของ DECATHLON ได้ตรวจพบว่า หากมีการถอดมือหมุนปรับระดับความสูงออก และผลิตภัณฑ์ถูกเคลื่อนย้ายหรือใช้งานหลังจากนั้น อาจเกิดความเสี่ยงที่เสาอาจเลื่อนลงในแนวดิ่งได้\n\nด้วยเหตุนี้ เราจึงขอความร่วมมือจากคุณในการตอบคำถามไม่กี่ข้อ เพื่อที่เราจะสามารถจัดหาแนวทางแก้ไขความปลอดภัยที่เหมาะสมให้กับผลิตภัณฑ์ของคุณ\n\nทางเราต้องขออภัยในความไม่สะดวกมา ณ โอกาสนี้ และขอขอบคุณสำหรับความไว้วางใจที่คุณมีต่อ DECATHLON เสมอมา\n\nด้วยความเคารพอย่างสูง ทีมงาน DECATHLON',
  'emailConfirmation': {
    'title': 'กรุณายืนยันที่อยู่อีเมลและประเทศที่คุณพำนักอยู่ในปัจจุบัน'
  },
  'fields': {
    'country': 'ประเทศ',
    'address': 'อีเมล์',
    'email': 'อีเมล์',
    'phonePrefix': 'รหัสประเทศ',
    'phone': 'เบอร์โทรศัพท์',
    'validations': {
      'phoneOrEmail': 'กรุณาระบุ อีเมล์ หรือ เบอร์โทรศัพท์ ของผู้ครอบครองผลิตภัณฑืในปัจจุบัน',
      'email': 'อีเมล์ ที่ติดต่อได้',
      'phone': 'เบอร์โทรศัพท์ ที่ติดต่อได้'
    },
    'firstName': 'นามสกุล',
    'lastName': 'ชื่อ',
    'deliveryAddress': 'ที่อยู่สำหรับจัดส่ง',
    'additionalAddress': 'ที่ี่อยู่จัดส่ง (เพิ่มเติม)',
    'city': 'เมือง/ จังหวัด',
    'zip': 'รหัสไปรษณีย์',
    'choose': 'เลือก',
    'required': 'ข้อมูลจำเป้น'
  },
  'ownerCheck': {
    'title': 'คุณยังคงเป็นเจ้าของห่วงบาสเกตบอลรุ่น B900 BOX NBA อยู่หรือไม่'
  },
  'yes': 'ใช่',
  'no': 'ไม่ใช่',
  'ownerChanged': {
    'title': 'Do you have the contact details of the current owner(s)?',
    'confirmation': 'เรียนคุณลูกค้าผู้มีอุปการคุณ\n\nขอขอบพระคุณสำหรับการมีส่วนร่วมในโครงการด้านคุณภาพของเรา\n\nทางเราขออภัยในความไม่สะดวกที่เกิดขึ้น และขอขอบคุณอีกครั้งสำหรับความไว้วางใจที่มีต่อ DECATHLON เสมอมา\n\nด้วยความเคารพอย่างสูง ทีมงาน DECATHLON'
  },
  'recall': {
    'title': 'กรุณาระบุจำนวนห่วงบาสเกตบอลรุ่น B900 BOX NBA ที่คุณมีอยู่ในปัจจุบัน พร้อมทั้งประเภทของมือหมุนที่ติดตั้งกับแต่ละชุด',
    'descriptionRed': 'ห่วงบาสเกตบอลที่ติดตั้งมือหมุนสีแดงซึ่งสามารถถอดออกได้',
    'descriptionBlack': 'ห่วงบาสเกตบอลที่ติดตั้งมือหมุนสีดำแบบยึดติดถาวร',
    'quantity': 'จำนวน',
    'notConcerned': 'เรียนคุณลูกค้าผู้มีอุปการคุณ,\n\nขอขอบพระคุณสำหรับการมีส่วนร่วมในโครงการด้านคุณภาพของเรา\n\nขอแจ้งให้คุณทราบว่า ห่วงบาสเกตบอลรุ่น Tarmak B900 BOX NBA ของคุณไม่ได้รับผลกระทบจากกระบวนการเรียกคืนผลิตภัณฑ์ และสามารถใช้งานได้อย่างปลอดภัย\n\nทางเราขออภัยในความไม่สะดวกที่อาจเกิดขึ้น และขอขอบคุณอีกครั้งสำหรับความไว้วางใจที่คุณมีต่อ DECATHLON',
    'concernedProductQuantity': 'จำนวนสินค้า ที่ไม่ได้มาตรฐาน',
    'concernedProductLabel': 'สินค้าไม่ได้มาตรฐาน',
    'confirmation': 'ขอขอบพระคุณที่กรอกแบบฟอร์มเรียบร้อยแล้ว ข้อมูลของคุณได้ถูกบันทึกอย่างสมบูรณ์\n\nทางเราจะส่งหมายเลขติดตามพัสดุสำหรับการจัดส่งชุดอุปกรณ์ให้คุณโดยเร็วที่สุด\n\nสำหรับประเทศในยุโรป จะจัดส่งผ่านระบบ FandiWeb\n\nสำหรับประเทศนอกยุโรป จะจัดส่งผ่านช่องทาง X\n\nขอให้คุณมีวันที่ดี และขอขอบคุณอีกครั้งสำหรับความไว้วางใจที่มีต่อ DECATHLON\n\nด้วยความเคารพอย่างสูง ทีมงาน DECATHLON'
  },
  'repair': {
    'title': 'การซ่อมแซมด้วยตนเอง',
    'description': 'เรียนลูกค้าผู้มีอุปการคุณ\n\nทางทีมงานได้ตรวจพบว่า ห่วงบาสเกตบอลรุ่น TARMAK B900 BOX NBA (หมายเลขอ้างอิง 4239136) บางชุดมีความเสี่ยงที่เสาอาจเลื่อนลง ในแนวดิ่ง หากมีการถอดมือหมุนออกแล้วมีการเคลื่อนย้ายหรือใช้งานผลิตภัณฑ์\n\nจากข้อมูลที่คุณให้ไว้ พบว่าผลิตภัณฑ์ของคุณเข้าข่ายได้รับผลกระทบจากความเสี่ยงดังกล่าว\n\nจึงขอความกรุณาให้คุณหยุดใช้งานผลิตภัณฑ์ทันที และทางเรายินดีให้ความช่วยเหลือในการปรับเปลี่ยนมือหมุน เพื่อให้คุณสามารถใช้งานผลิตภัณฑ์ได้อย่างปลอดภัย',
    'videoLink': 'ลิ้งค์วีดีโอ',
    'docLink': 'ลิ้ิ้งค์เอกสาร',
    'callToAction': 'คลิกที่นี่ เพื่อรับชุดอปกรณ์ซ่อมแซม "ฟรี"',
    'warranty': 'ขั้นตอนทั้งหมด อยู่ภายใต้การรับประกัน 5 ปี'
  },
  'repairRequest': {
    'title': 'กรุณากรอกข้อมูลต่อไปนี้ เพื่อให้ทางเราจัดส่งชุดอุปกรณ์ซ่อมแซม ไปยังที่อยู่ ที่ท่านต้องการได้'
  },
  'form': {
    'submit': 'ต่อไป'
  },
  'status': 'Translation validated by COUNTRY'
} as const
